function normalizeCodeNamePart(value: string): string {
  return value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
}

/** Preview the same first-name + last initial default used when a code is created. */
export function defaultDiscountCodePreview(firstName: string, lastName = ""): string {
  const first = normalizeCodeNamePart(firstName).slice(0, 12) || "FRIEND";
  const lastInitial = normalizeCodeNamePart(lastName).slice(0, 1);
  return `${first}${lastInitial}`;
}
